import { ArrowUpCircleIcon } from '@heroicons/react/24/solid';
import './UpgradePlanBadge.css';

type UpgradePlanBadgeProps = {
  size?: 'sm' | 'md';
};

export default function UpgradePlanBadge({ size = 'md' }: UpgradePlanBadgeProps) {
  return (
    <span
      className={`upgrade-plan-badge upgrade-plan-badge--${size}`}
      aria-label="Upgrade plan required"
      title="Upgrade plan required"
    >
      <ArrowUpCircleIcon aria-hidden />
      <span className="upgrade-plan-badge__label">Upgrade</span>
    </span>
  );
}
